import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { FieldType } from '@ngx-formly/core';
import { TranslatePipe } from '@ngx-translate/core';
import { ButtonModule } from 'primeng/button';
import { TooltipModule } from 'primeng/tooltip';

type FormlyButtonProps = {
  btnType: string;
  className: string;
  link: string;
  translate: boolean;
  text: string;
  tooltip: string;
  outlined: boolean;
  styleClass: string;
  disabled: boolean;
  externalUrl: string;
  onClick: (event: Event, field?: any, formState?: any) => void;
  internalUrl: string;
  queryParams: string;
}

@Component({
  selector: 'formly-field-button',
  template: `
      <p-button
        [label]="to.translate ? (to.text | translate) : to.text"
        [severity]="to.btnType === 'link' ? undefined : (to.btnType??'primary')"
        [link]="to.btnType === 'link'"
        [outlined]="!!to.outlined"
        [styleClass]="to.styleClass"
        [disabled]="!!to.disabled"
        (onClick)="onClick($event)"
        [class]="to.className"
        [pTooltip]="to.tooltip ? (to.translate ? (to.tooltip | translate) : to.tooltip) : undefined"
        tooltipPosition="top"
      />
  `,
  standalone: true,
  imports: [
    CommonModule,
    ButtonModule,
    TooltipModule,
    TranslatePipe,
  ]
})
export class FormlyFieldButton extends FieldType {

  constructor(
    private router: Router) {
    super();
  }

  onClick($event) {
    let props = this.props as FormlyButtonProps;
    if (props.onClick) {
      props.onClick($event, this.field, this.options?.formState);
    }
    if (props.externalUrl) {
      window.location.href = props.externalUrl;
    }
    if (props.internalUrl) {
      //https://stackoverflow.com/questions/8648892/how-to-convert-url-parameters-to-a-javascript-object
      //let x = [...new URLSearchParams(props.queryParams)].reduce((o, i) => ({ ...o, [i[0]]: i[1] }), {});
      //more recent version from the same SO page:
      const x = Object.fromEntries(new URLSearchParams(props.queryParams));

      this.router.navigate([props.internalUrl], { queryParams: x });
    }
  }
}